import { render, staticRenderFns } from "./rekonapkr.vue?vue&type=template&id=4fbfefa4&scoped=true"
import script from "./rekonapkr.vue?vue&type=script&lang=js"
export * from "./rekonapkr.vue?vue&type=script&lang=js"
import style0 from "./rekonapkr.vue?vue&type=style&index=0&id=4fbfefa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbfefa4",
  null
  
)

export default component.exports